import { NewSite, Site } from "../models/site";
import axiosConfig from "./axiosConfig";

export interface PostSiteResponse extends Site {
  site_id: string;
}

const postSite = async (
  authToken: string,
  site: NewSite,
  userOrgId?: string
): Promise<PostSiteResponse> => {
  const { data } = await axiosConfig.post(
    `/site${userOrgId ? `?userOrgId=${userOrgId}` : ""}`,
    site,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default postSite;
